<template>
    <div class="intGlobalUpdate">
        <ValidationObserver ref="form" v-slot="{handleSubmit}">
            <form @submit.prevent="handleSubmit(send)">
                <vs-row>
                    <vs-col vs-w="12">
                        <div class="p-2">
                            <ValidationProvider vid="endpoint" :name="$t('global.Endpoint')" rules="required|max:250|url" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Endpoint')}}</label>
                                <vs-input
                                    name="endpoint"
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.Endpoint')"
                                    v-model="params.endpoint"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="login" :name="$t('modals.Login')" rules="required|max:250" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('modals.Login')}}</label>
                                <vs-input
                                    name="login"
                                    class="inputx w-full no_focus"
                                    autocomplete="disabled"
                                    :placeholder="$t('modals.Login')"
                                    v-model="params.login"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="password" :name="$t('modals.Password')" rules="required|max:250" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('modals.Password')}}</label>
                                <vs-input
                                    type="password"
                                    name="password"
                                    autocomplete="disabled"
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('modals.Password')"
                                    v-model="params.password"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="12">
                        <div class="p-2 text-right">
                            <vs-button :disabled="loading" button="submit" ref="btn">{{ $t('buttons.Update') }}</vs-button>
                        </div>
                    </vs-col>
                </vs-row>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import EventBus from "@/store/eventBus";
export default {
    props: ['popupData', 'popupType', 'popupButton'],

    data() {
        return {
            loading: false,
            params: {
                advertiser_id: '',
                endpoint: '',
                login: '',
                password: ''
            }
        }
    },

    methods: {
        async send() {
            try {
                this.loading = true
                const params = {...this.params}
                Object.keys(params).map(key => {
                    if (!params[key]) delete params[key]
                })

                await send(this.$url.advrtsr_integration["integration-update-all"], 'PATCH', {params})
                EventBus.$emit('intGlobalUpdate')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                if(e.response && e.response.data && e.response.data.result) {
                    const response = e.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(e).send
            } finally {
                this.loading = false
            }
        }
    },

    mounted() {
        this.params.advertiser_id = this.popupData.id

        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
